define(function (require, exports, module) {
    return {
        TFS_TIMER_TICK: 'tfs_timer_tick',
        INIT_DATA_LOADED: 'init_data_loaded',
        GAME_INITIALIZED: 'game_data_initialized',
        PREGAME_UPDATE: 'pregame_update',
        GAME_STATE_UPDATE: 'game_state_changed',
        UPDATE: 'abstract_update',
        TIMECODE: 'timecode_update',
        PATCH_ERROR: 'patch_error',
        CONNECTION_ERROR: 'connection_error'
    };
});
